import React from "react";
import ModalBox from "../../../components/modal/ModalBox";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../../comman/Message";
import { hideMeetupApi } from "../../../services/meetups";

const HideMeetupEvent = ({ show, close, id, listing, name }) => {
  //--------------change-status-meetups-------------------------
  const hideEvent = async () => {
    try {
      const res = await hideMeetupApi(id);
      if (res.data.status === 200) {
        close();
        listing();
        successMessage(res);
      } else {
        elseMessage(res);
      }
    } catch (e) {
      catchMessage(e);
    }
  };

  return (
    <ModalBox
      status={show}
      onClose={close}
      title={` Meetups`}
      description={
        <span>
          Do you want to Hide <strong>{name}</strong> ?
        </span>
      }
      action={hideEvent}
    />
  );
};

export default HideMeetupEvent;
